module.exports = __webpack_public_path__ + "img/IMG_6726_L_WoodMatted_MockedUp.bb6a79b4.jpg";